import React, { useState, useEffect, useContext } from "react";
import styles from "./PlayerStats.module.scss";
import ChangePassword from "../ChangePassword/ChangePassword";
import ScoreComputer from '../../../utils/ScoreComputer/ScoreComputer';
import Flags from '../../../utils/Flags/Flags';  
import { useAuth } from "../../../context/AuthContext";

// API
import { getLastsProgressionsByUser } from '../../../utils/api/progressionAPI';
import { getLastsProgressionsIndeByUser } from '../../../utils/api/progressionIndeAPI';
// import { getAllScoresByUser } from '../../../utils/api/scoresAPI';
// import { getVillage } from '../../../utils/api/villagesAPI';
import { updatePassword } from '../../../utils/api/usersAPI';

import { LanguageContext } from '../../../context/LanguageContext';
// Import des traductions 
import translations from '../../../utils/translations/PlayerStatsTranslations';

const PlayerStats = ({ userId }) => {

  const { user } = useAuth(); // Récupère l'utilisateur connecté

  // Utilisation du contexte de langue global
  const { language, changeLanguage } = useContext(LanguageContext);

  // Accès simplifié aux traductions
  const t = translations[language] || translations.fr;

  const [parcours, setParcours] = useState([]); // Toutes les données de progression des villages
  const [games, setGames] = useState([]); // Toutes les données de progression des jeux insolites
  const [loading, setLoading] = useState(true);

  const [infos, setInfos] = useState([]); // Toutes les données de progression des jeux indépendants (par langues)

  useEffect(() => {
    const fetchScores = async () => {
      try {
        const progDatas = await getLastsProgressionsByUser(localStorage.getItem("userId"));
        setParcours(progDatas);
        const progIndeDatas = await getLastsProgressionsIndeByUser(localStorage.getItem("userId"));
        setGames(progIndeDatas);
        setLoading(false);
      } catch (error) {
        console.error("Erreur lors du chargement des scores:", error);
        setLoading(false);
      }
    };
    
    fetchScores();
  }, [userId]);


  const renderProgressBar = (parcoursInfo) => {
    const { scores } = parcoursInfo;
    const totalQuestions = parcoursInfo.nb_questions;
    
    if (totalQuestions === 0) return null;
    
    return (
      <div className={styles.progressContainer}>
        <div className={styles.progressBar}>
          {scores.map((question, index) => {
            // Calculer la position du marqueur en pourcentage
            const position = `${(index / (totalQuestions - 1)) * 100}%`;
            
            // Déterminer la classe CSS en fonction de l'état de la question
            let markerClass = styles.unansweredMarker;
            if (question.elapsed_time !== null) {
              markerClass = (!question.aborted && question.nb_compass > 0) 
                ? styles.successMarker 
                : styles.failedMarker;
            }
            
            return (
              <div 
                key={question.id_question || index}
                className={`${styles.questionMarker} ${markerClass}`}
                style={{ left: position }}
                title={`${question.elapsed_time !== null ? `Temps: ${question.elapsed_time}s - Boussoles: ${question.nb_compass}` : 'Non répondue'}`}
              />
            );
          })}
          
          {/* Barre de progression remplie en fonction du nombre de questions répondues */}
          <div 
            className={styles.progressFill}
            style={{ 
              width: `${(scores.filter(q => q.elapsed_time !== null).length / totalQuestions) * 100}%`,
              backgroundColor: scores.filter(q => q.elapsed_time !== null).length === totalQuestions ? '#836865' : 'rgb(129, 124, 95)'
            }}
          />
        </div>
        
        <div className={styles.progressInfo}>
          {scores.filter(q => q.elapsed_time !== null).length === totalQuestions ? (
            <div className={styles.completed}>
              <span className={styles.score}>
                  <ScoreComputer questions={parcoursInfo.scores} /> pts
              </span>
              <span>
                {t.completedParcoursLabel}
              </span>
            </div>
          ) : (
            <span>
              {t.progressionLabel}: {scores.filter(q => q.elapsed_time !== null).length}/{totalQuestions}
            </span>
          )}
        </div>

      </div>
    );
  };
  
  if (loading) {
    return <div>{t.loading}</div>;
  }
  
  return (
    <div className={styles.playerStats}>
      <h2>{t.villageHistoryTitle}</h2>
      {parcours.length === 0 ? (
        <p className={styles.message}>{t.noParcoursAvailable}</p>
      ) : (
        <ul className={styles.parcoursList}>
          {parcours
            .filter(p => p.scores.some(q => q.elapsed_time !== null)) // Ne montrer que les parcours avec au moins une question répondue
            .map((parcoursInfo) => (
              <li key={parcoursInfo.id} className={styles.parcoursItem}>
                <div className={styles.parcoursHeader}>
                  <h3>{parcoursInfo.village_nom || t.unknownVillage} - {parcoursInfo.parcours_nom}</h3>
                  <div>
                  {parcoursInfo.completed && (
                      <span className={styles.score}><ScoreComputer questions={parcoursInfo.scores} /> pts</span>
                    )}
                  </div>
                </div>
                <div>{renderProgressBar(parcoursInfo)}</div>
                
              </li>
            ))}
        </ul>
      )}

      <h2>{t.partnerHistoryTitle}</h2>
      {parcours.length === 0 ? (
        <p className={styles.message}>{t.noPartnerData}</p>
      ) : (
        <ul className={styles.parcoursList}>
          {games
            .filter(p => p.scores.some(q => q.elapsed_time !== null)) // Ne montrer que les parcours avec au moins une question répondue
            .map((parcoursInfo) => (
              <li key={parcoursInfo.id} className={styles.parcoursItem}>
                <div className={styles.parcoursHeader}>
                  <h3>{parcoursInfo.game_nom || t.unknownGame} - <Flags lang={parcoursInfo.lang} /></h3>
                  <div>
                    {parcoursInfo.completed && (
                      <span className={styles.score}><ScoreComputer questions={parcoursInfo.scores} /> pts</span>
                    )}
                  </div>
                </div>
                <div>{renderProgressBar(parcoursInfo)}</div>
                
              </li>
            ))}
        </ul>
      )}


      {/* <h2>Classement général</h2> */}

      {/* <hr />
      <h2>{t.changePasswordTitle}</h2>
      <ResetPasswordForm onSubmit={handlePasswordSubmit} loading={loading} /> */}
      <ChangePassword />
      
    </div>
  );
};

export default PlayerStats;